(function () {
  'use strict';

  var SLACK = 10;

  function countTokens(text) {
    var trimmed = (text || '').replace(/\s+/g, ' ').trim();
    return trimmed ? trimmed.split(' ') : [];
  }

  function truncateToWords(root, maxWords) {
    var remaining = maxWords;
    var lastElement = null;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;

    while ((node = walker.nextNode())) {
      var parts = node.textContent.split(/\s+/).filter(Boolean);

      if (remaining <= 0) {
        node.textContent = '';
        continue;
      }

      if (parts.length <= remaining) {
        remaining -= parts.length;
        if (parts.length) lastElement = node.parentNode;
      } else {
        node.textContent = parts.slice(0, remaining).join(' ');
        lastElement = node.parentNode;
        remaining = 0;
      }
    }

    return lastElement;
  }

  class ReadMoreText extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      var content = this.querySelector('.read-more__content');
      if (!content) return;

      var words = parseInt(this.getAttribute('data-words'), 10);
      if (!words || words < 1) words = 20;
      var label = this.getAttribute('data-button-label') || 'Mehr erfahren';

      var tokens = countTokens(content.textContent);
      if (tokens.length <= words + SLACK) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'read-more__toggle';
      button.textContent = label;
      button.setAttribute('aria-expanded', 'false');

      var preview = content.cloneNode(true);
      preview.removeAttribute('id');
      preview.className = content.className.replace('read-more__content', 'read-more__preview').trim();
      preview.setAttribute('aria-hidden', 'true');

      var host = truncateToWords(preview, words) || preview;
      host.appendChild(document.createTextNode('… '));
      host.appendChild(button);

      Array.prototype.forEach.call(preview.querySelectorAll('*'), function (el) {
        if (el === button || el.contains(button)) return;
        if (el.textContent.trim() === '' && !el.querySelector('img, svg, picture, video')) {
          el.remove();
        }
      });

      content.hidden = true;
      this.insertBefore(preview, content);

      button.addEventListener('click', function () {
        content.hidden = false;
        preview.hidden = true;
        button.setAttribute('aria-expanded', 'true');
      });
    }
  }

  if (!window.customElements.get('read-more-text')) {
    window.customElements.define('read-more-text', ReadMoreText);
  }
})();
